"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("../constants");
var mediaQuery = function mediaQuery(breakpoint) {
  return function (strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    if (strings) {
      var declaration = strings.reduce(function (accumulator, currentValue, index) {
        accumulator += currentValue + (values[index] || '');
        return accumulator;
      }, '');
      return "@media (min-width: ".concat(_constants.BREAKPOINT[breakpoint], "px) {\n      ").concat(declaration, "\n    }");
    }
    return "@media (min-width: ".concat(_constants.BREAKPOINT[breakpoint], "px)");
  };
};
var _default = exports["default"] = Object.keys(_constants.BREAKPOINT).reduce(function (accumulator, breakpoint) {
  accumulator[breakpoint.toLowerCase()] = mediaQuery(breakpoint);
  return accumulator;
}, {});